import type { TemplateDetail, TemplateSummary } from '../types';

export const mockTemplates: TemplateDetail[] = [
  {
    id: '9501',
    title: 'Encuesta de satisfacción (plantilla)',
    description: 'Plantilla base para medir satisfacción del equipo.',
    emailRequired: false,
    fields: [
      {
        id: '0',
        fieldType: 'Select',
        label: 'Prioridad',
        required: true,
        order: 0,
        options: '["Baja","Media","Alta","Urgente"]',
        validation: null,
      },
      {
        id: '1',
        fieldType: 'TextArea',
        label: 'Comentarios',
        required: false,
        order: 1,
        options: null,
        validation: null,
      },
      {
        id: '2',
        fieldType: 'LinearScale',
        label: '¿Qué tan satisfecho estás?',
        required: true,
        order: 2,
        options: '{"min":1,"max":5,"minLabel":"Nada satisfecho","maxLabel":"Muy satisfecho"}',
        validation: null,
      },
    ],
    createdAt: '2026-06-10T09:00:00Z',
    updatedAt: '2026-07-01T09:00:00Z',
  },
  {
    id: '9502',
    title: 'Solicitud de permiso (plantilla)',
    description: 'Plantilla estándar de RRHH para solicitudes de permiso.',
    emailRequired: true,
    fields: [
      {
        id: '0',
        fieldType: 'Select',
        label: 'Tipo de permiso',
        required: true,
        order: 0,
        options: '["Vacaciones","Enfermedad","Personal"]',
        validation: null,
      },
      {
        id: '1',
        fieldType: 'Date',
        label: 'Fecha de inicio',
        required: true,
        order: 1,
        options: null,
        validation: null,
      },
      {
        id: '2',
        fieldType: 'Date',
        label: 'Fecha de fin',
        required: true,
        order: 2,
        options: null,
        validation: null,
      },
    ],
    createdAt: '2026-05-20T09:00:00Z',
    updatedAt: '2026-06-15T09:00:00Z',
  },
];

export function toTemplateSummary(template: TemplateDetail): TemplateSummary {
  return {
    id: template.id,
    title: template.title,
    description: template.description,
    fieldCount: template.fields.length,
    createdAt: template.createdAt,
    updatedAt: template.updatedAt,
  };
}
